import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col } from 'react-flexbox-grid';
import CustomInput from "../../common/customInput";
import Button from "../../common/button";
import Amanda from "../../images/farmfit/IMG_7134.jpg";
import { TransitionEaseInOne } from "../../common/transitions";
import { loginUser } from "../../../actions";
import { getUserDetails } from "../../../selectors";

const RegisterUser = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const userDetails = props.userDetails.toJS();
  useEffect(() => {
    // Get email from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, []);

  useEffect(() => {
    if (userDetails.isLoggedIn) {
      window.location = "/recipes";
    }
  }, [userDetails.isLoggedIn])

  const handleSubmit = (e) => {
    e.preventDefault();
    validateData();
    setError("");
    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    setIsLoading(true);
    fetch(`${process.env.REACT_APP_WHITELABEL_URL}/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.id) {
          props.loginUser(email, password);
        } else {
          setError("Registration failed. Please contact the support team.");
          setIsLoading(false);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        setError("Error registering user! Please contact the support team.");
        setIsLoading(false);
      });
  };

  const validateData = () => {
    if (!email || !password) {
      setError("Please enter both email and password");
    }
    return;
  }
  return (
    <>
      <section
        className="login-section">
        <Helmet>
          <title>Register | Farm Fit Fuel</title>
          <meta name="description" content="Dashingdish Register page" />
        </Helmet>
        <Row className="no-margin">
          <Col xs={12} md={12} lg={6} className="no-padding-sm">
            <TransitionEaseInOne>
              <div className="login-wrapper">
                <div className="loginBlock">
                  <h1>Register to Farm Fit Fuel</h1>
                  <form onSubmit={handleSubmit}>
                    <CustomInput
                      type="email"
                      name="email"
                      placeholder="Type here"
                      className="error"
                      label="Email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      readOnly={!!new URLSearchParams(window.location.search).get('email')}
                      disabled={!!new URLSearchParams(window.location.search).get('email')}
                    />
                    <CustomInput
                      type="password"
                      name="password"
                      placeholder="Enter password here"
                      className="error"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      label="Password"
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSubmit(e);
                        }
                      }}
                    />
                    <div className="globalErrorWrapper">
                      {error && <p className="error-message">{error}</p>}
                    </div>
                    <Button
                      type="submit"
                      btnClass="primary btn-md"
                      btnText="Register"
                      onClick={handleSubmit}
                      loading={isLoading}
                      disabled={isLoading}
                    />
                  </form>
                </div>
              </div>
            </TransitionEaseInOne>
          </Col>
          <TransitionEaseInOne>
            <Col xs={12} md={12} lg={6} className="image-bg-wrapper"
              style={{
                backgroundImage: `url(${Amanda})`,
              }}
            >
            </Col>
          </TransitionEaseInOne>
        </Row>
      </section >
    </>
  );
}

const mapStateToProps = (state) => ({
  userDetails: getUserDetails(state),
});

const dispatchActionToProps = (dispatch) => ({
  loginUser: bindActionCreators(loginUser, dispatch),
});

export default connect(mapStateToProps, dispatchActionToProps)(RegisterUser);
